import React from 'react'
import { CoachColumn } from '../../styles'
import { Coach } from './Coach'
export const Coaches: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <>
<CoachColumn>
  <Coach side="left" />
</CoachColumn>
<CoachColumn>
  <Coach side="right" />
</CoachColumn>
</>
  )
}
